import React from 'react'

const SVG = ({
  style = { fill: '#666666' },
  viewBox = '0 0 18 14.439',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox}
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...rest}
  >
    <g transform='translate(0 -4)'>
      <g data-name='Group 45' transform='translate(0 3.999)'>
        <path d='M17.846 12.711L9.96.5a1.129 1.129 0 0 0-.936-.5 1.06 1.06 0 0 0-.612.18 1.111 1.111 0 0 0-.324.32L.2 12.711a1.069 1.069 0 0 0-.144.846 1.147 1.147 0 0 0 .486.7 1.15 1.15 0 0 0 .594.18H16.91a1.117 1.117 0 0 0 .792-.324 1.087 1.087 0 0 0 .324-.792 1.022 1.022 0 0 0-.18-.61zm-16.258.342L9.024 1.566l7.436 11.487z' data-name='Path 44' transform='translate(-.026)' />
      </g>
      <g data-name='Group 46' transform='translate(7.968 7.996)'>
        <path d='M44.429 22.416a.553.553 0 0 0-.144.432l.144 4.645c.018.216.324.378.54.378h.684a.4.4 0 0 0 .36-.378l.288-4.681a.585.585 0 0 0-.18-.432.629.629 0 0 0-.432-.18h-.846a.835.835 0 0 0-.414.216z' data-name='Path 45' transform='translate(-44.281 -22.2)' />
      </g>
      <g data-name='Group 47' transform='translate(7.954 14.55)'>
        <path d='M45.244 58.6a1.044 1.044 0 1 0 1.044 1.044 1.045 1.045 0 0 0-1.044-1.044z' data-name='Path 46' transform='translate(-44.2 -58.6)' />
      </g>
    </g>
  </svg>
)
export default SVG
